import { useState, useRef, useEffect } from "react";
import { ChevronDown, Coins } from "lucide-react";
import { useFx } from "../lib/fx";
import { cx } from "../lib/api";

export default function CurrencySwitcher({ compact = false }) {
  const { currencies, userCurrency, setUserCurrency } = useFx();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  if (!currencies.length) return null;
  const active = currencies.find((c) => c.code === userCurrency) || currencies[0];

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        className={cx(
          "inline-flex items-center gap-1.5 rounded-full border hairline transition hover:border-teal/40 hover:text-teal",
          compact ? "h-8 px-2 text-[12px]" : "h-9 px-3 text-[13px]"
        )}
        data-testid="currency-switcher"
        aria-label="Change currency"
      >
        <Coins size={12} />
        <span className="font-mono">{active.code}</span>
        <ChevronDown size={12} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-56 max-h-80 overflow-y-auto glass-solid rounded-2xl shadow-ink p-1.5 z-50" data-testid="currency-menu">
          {currencies.map((c) => (
            <button key={c.code}
                    onClick={() => { setUserCurrency(c.code); setOpen(false); }}
                    className={cx(
                      "w-full flex items-center justify-between gap-2 text-left px-3 py-2 rounded-xl hover:bg-white/5 transition",
                      c.code === userCurrency && "bg-teal/10 text-teal"
                    )}
                    data-testid={`currency-opt-${c.code}`}>
              <span className="flex items-center gap-2">
                {c.icon_url ? (
                  <img src={c.icon_url} alt="" className="h-4 w-4 rounded-full"/>
                ) : (
                  <span className="font-mono text-[11px] w-4 text-center">{c.symbol || c.code[0]}</span>
                )}
                <span className="font-mono text-[12px]">{c.code}</span>
                <span className="text-[11px] text-muted truncate">{c.name}</span>
              </span>
              <span className={cx("chip !text-[10px] !py-0",
                                  c.kind === "fiat" ? "" : c.kind === "crypto" ? "info" : "success")}>
                {c.kind}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
